import actions from "./settings-actions";
import getters from "./settings-getters";
import mutations from "./settings-mutations";
import state from "./settings-state";
const settingsStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default settingsStore;